import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { WizardDraft, WizardDraftClient } from 'api/clients/WizardDraftClient'
import { useQueryClient } from 'react-query'

export const useDeleteWizardDraft = () => {
  const queryClient = useQueryClient()

  return useMutation<undefined, unknown, WizardDraft>(
    'deleteWizardDraft',
    async (wizardDraft) => {
      const response = await WizardDraftClient.deleteDraft(wizardDraft.id)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return undefined
    },
    {
      onSuccess(_, { id, workspace_id }) {
        queryClient.setQueryData(['wizardDrafts', workspace_id], (oldData) => {
          return ((oldData || []) as WizardDraft[]).filter((draft) => draft.id !== id)
        })
      },
    },
  )
}
